module.exports = __webpack_public_path__ + "img/event_mb_tab_01.3c30d8c9.png";